import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import m from 'js-md5';
import { G } from '../encrypt/index'

import store from '@/store'
import { getMachineId, getSmDeviceId, getStorage, setStorage } from '_lib/utils/utils'
import { logout } from '_api/login'
import EventBus from '@/common/EventBus'

const REPORT_SM_DEVICE_ID_APIS = [
  // 登录相关
  '/account/login/',
  '/account/wechat/login/v2/heybox_chat/',
  '/account/login_code/',
  '/account/get_login_code/',
  '/account/heychat/get_qr/',
  '/account/web_login_with_token/',

  // 支付相关
  '/pay/heychat_pay',

  // 帖子相关
  '/bbs/app/link/web/view',
  '/bbs/app/link/tree',
  '/bbs/app/topic/feeds',
  '/bbs/app/api/link/post',
  '/bbs/app/profile/events',
  '/bbs/app/profile/history/visit',
  '/bbs/app/comment/create',
  '/bbs/app/comment/support',

  // 组队相关
  '/game/common_team_v2/publish',
  '/game/common_team_v2/join_team',
  '/game/common_team_v2/leave_team',

  // 发送消息相关
  '/chatroom/v2/msg/user',
  '/chatroom/v2/channel_msg/send',
  '/chatroom/v2/msg/update',
  '/chatroom/msg/revoke',
  '/chatroom/v1/msg/reply_emoji'
]

const Axios = axios.create()
Axios.create = axios.create
Axios.all = axios.all

const auto_reload_ts_key = 'hc_auto_reload_ts'
let timeoutToastLock = false

// Axios连续失败次数
let axiosErrorTime = 0

// Axios连续失败次数重置 
let axiosErrorTimeout = null

// Axios连续失败提示更改DNS设置
let isAxiosErrorAlert = false


let logoutPromise = null

Axios.interceptors.request.use(
  async (config) => {
    if (REPORT_SM_DEVICE_ID_APIS.indexOf(config.url.replace(/^.*\/\/[^/]+/, '')) >= 0) {
      let device_id = await getSmDeviceId()
      if (!device_id) {
        Vue.prototype.$toast.error('获取数美device_id失败')
        return Promise.reject('getSmDeviceId 获取数美device_id失败');
      }
      config.data = {
        x_xhh_tokenid: device_id,
        ...config.data
      }
    }

    let p = {
      ...config.params
    }

    // 时间戳
    let t = ~~(+G.w() / 1000);

    // nonce生成
    let n = m(
      t + Math.random(new Date().getTime()).toString(),
    ).toLocaleUpperCase();

    p.hkey = G.g(new URL(config.url).pathname, t, n)

    p.nonce = n
    p._time = t

    if(process.env.IS_CLIENT) {
      if(store.getters.device_id) {
        p.device_id = store.getters.device_id
      } else {
        const device_id = await getMachineId()
        p.device_id = device_id
      }
    }
    config.params = p

    if (config.method === `POST`) {
      if (!config.upload) {
        config.data = {
          ...config.data,
        }
        if (!config.headers['Content-Type'].includes('application/json')) {
          config.data = qs.stringify(config.data, { indices: false });
        }
      }
    }
    config.withCredentials = true
    return config;
  },
  (error) => {
    return Promise.reject(error.message);
  }
)


Axios.interceptors.response.use(
  (res) => {
    axiosErrorTime = 0
    let status_key = res.data.status
    if (status_key == 'relogin' && !res.config.params['_norelogin']) {
      if(store.getters.is_login && !logoutPromise){
        logoutPromise = new Promise(async (resolve, reject) => {
          try {
            let auto_reload_ts =( await getStorage(auto_reload_ts_key)) || []
            if (Array.isArray(auto_reload_ts) && auto_reload_ts.length >= 3) {
              let early_ts = auto_reload_ts.sort().shift(), ts = new Date().getTime()
              if (ts - early_ts > 10 * 1000) {
                resolve(logout().finally(() => {
                  auto_reload_ts.push(new Date().getTime())
                  setStorage(auto_reload_ts_key, auto_reload_ts)
                  window.location.reload()
                }))
              } else {
                setStorage(auto_reload_ts_key, '')
              }
            } else {
              logout().finally(() => {
                auto_reload_ts.push(new Date().getTime())
                setStorage(auto_reload_ts_key, auto_reload_ts)
                window.location.reload()
              })
            }
          } catch(e) {
            console.error(e);
            reject()
          }
        })
      }
    } else if (status_key === 'redirect_room') {
      EventBus.$dynamic('RoomRedirectDialog', res.data.result)
    } else if (!['ok', 'block_room'].includes(status_key) && res.data.msg) {
      if (res.data.msg.indexOf('数据上报失败') == -1 && res.data.msg != '请先验证' &&  res.data.msg != 'no_toast' && !res.config.params['_notip']) {
        Vue.prototype.$toast.error(res.data.msg)
      }
    }
    if (process.env.IS_CLIENT && store.getters.show_dns_tip_bar) {
      store.commit('SET_SHOW_DNS_TIP_BAR', false)
    }
    return res
  },
  (error) => {
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      // 处理超时错误
      if (!timeoutToastLock) {
        Vue.prototype.$toast.error('请求超时，请刷新重试')
        timeoutToastLock = true
        setTimeout(() => {
          timeoutToastLock = false
        }, 2000)
      }
    } else {
      // 处理其他错误
      console.error(error);
    }
  
    // 如果是403，说明是后端检验拦截，toast msg信息即可
    let isForbidden = error.response && error.response.status === 403 
    if (isForbidden) {
      let msg = error.response.data?.msg
      msg && Vue.prototype.$toast.error(msg)
    } else if (process.env.IS_CLIENT && !store.getters.show_dns_tip_bar) {
      // 黑盒语音客户端无法连接成功提示，提示由于vpn，防火墙等拦截导致的接口返回失败
      // 判断条件：5s内有超过5个接口请求失败，仅提示一次 (deprecated)
      // 24.10.10 优化 判断条件：90s内连续失败3次，仅提示一次 
      axiosErrorTime += 1
      if (axiosErrorTime > 2) {
        store.commit('SET_SHOW_DNS_TIP_BAR', true)
      }
      if (!axiosErrorTimeout) {
        axiosErrorTimeout = setTimeout(() => {
          axiosErrorTime = 0
          axiosErrorTimeout = null
        }, 90 * 1000)
      }
    }
  
    return Promise.reject(error);
  }
)

export default Axios